import { Box, useTheme } from '@mui/material';
import { renderEntityUpdated as renderDefaultEntityUpdated } from '@core/audit/renderers/entityCrud';
import type { AuditLogRenderer } from '@core/utils/auditLog';
import { HistoryLines } from '../HistoryLines';
import { type ItemEditSentence, itemEditSentence } from '../historyLabel';
import { historyLabelTextColor } from '../historyLabelColor';

function EntityUpdatedLines({ sentence }: { sentence: ItemEditSentence }) {
  const theme = useTheme();
  const action = sentence.actionLabel ? (
    <>
      {sentence.action}{' '}
      <Box
        component="span"
        sx={{
          color:
            historyLabelTextColor(theme, sentence.actionColor) ?? 'inherit',
        }}
      >
        {sentence.actionLabel}
      </Box>
    </>
  ) : (
    sentence.action
  );

  return (
    <HistoryLines
      title={sentence.label}
      action={action}
      color={sentence.color}
    />
  );
}

export const renderEntityUpdated: AuditLogRenderer = (entry) => {
  const sentence = itemEditSentence(entry);
  if (!sentence) {
    return renderDefaultEntityUpdated(entry);
  }

  return <EntityUpdatedLines sentence={sentence} />;
};
